"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../controllers/BaseController");
var DlgErrorCtl = /** @class */ (function (_super) {
    __extends(DlgErrorCtl, _super);
    function DlgErrorCtl() {
        return _super.call(this, true) || this;
    }
    DlgErrorCtl.prototype.ResetData = function () {
        this.DATA = {
            onOk: null,
            visible: false,
            message: "",
            title: ""
        };
    };
    DlgErrorCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgErrorCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgErrorCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgErrorCtl.prototype.SetMessage = function (val) {
        this.DATA.message = val;
        this.Update();
        return this;
    };
    DlgErrorCtl.prototype.SetTitle = function (val) {
        this.DATA.title = val;
        this.Update();
        return this;
    };
    DlgErrorCtl.prototype.ClearFields = function () {
        this.ResetData();
        return this;
    };
    DlgErrorCtl.prototype.SetOnOkClick = function (callback) {
        this.DATA.onOk = callback;
        this.Update();
        return this;
    };
    return DlgErrorCtl;
}(BaseController_1.BaseController));
exports.DlgErrorCtl = DlgErrorCtl;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ctl/DlgErrorCtl.ts
// module id = 891
// module chunks = 0